import React, { useRef, useState } from 'react';
import uploadImg from "../../assets/images/upload.png";
import editIcon from "../../assets/images/editIcon.png"

function CustomFileUpload(props) {

    const [isHovered, setIsHovered] = useState(false);
    const fileInputRef = useRef(null);

    const handleEditClick = () => {
        fileInputRef.current.click();
    };

    return (
        <div className='img_upload_section'>
            <div
                className="upload_sign"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}>
                <input
                    type="file"
                    name="image"
                    className="img_upload_section_file"
                    ref={fileInputRef}
                    style={{ display: 'none' }} // Hide the file input
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={(e) => props.onFileChange(e.target.files[0])}
                />
                {props.file ? (
                    <div className="image-container-edit">
                        <img src={props.file} alt="Uploaded" className="upload_sign_after_img" />
                        {isHovered && (
                            <div className="overlay" title='click on edit icon to upload image again'>
                                <img src={editIcon} alt='' onClick={handleEditClick} className='edit-icon' />
                            </div>
                        )}
                    </div>
                ) : (
                    <img src={uploadImg} alt="Upload" onClick={handleEditClick} className="upload_sign_img" />
                )}
            </div>
        </div>
    );
}

export default CustomFileUpload;